import { render } from "./BlockScan.vue?vue&type=template&id=2db28baa"
import script from "./BlockScan.vue?vue&type=script&lang=js"
export * from "./BlockScan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__